import React from 'react'

function tokhandbooks() {
  return (
    <div>
      <h1>Tok Handbooks</h1>
    </div>
  )
}

export default tokhandbooks
